import angular from 'angular';
import config from './talks.config';

import {Talks} from './talks.component';
import {AddTalk} from './add-talk/add-talk.component';
import {EditTalk} from './edit-talk/edit-talk.component';

import AddStudentController from './../settings/add-student/add-student.controller';
import ViewTalkController from './view-talk/view-talk.controller';
import AddTalkStudentController from './add-talk-student/add-talk-student.controller';

import './talks.scss';

/**
 * @desc  Module initialize.
 *
 * @ngInject
 */
export default angular
  .module('app.modules.talks', [])
  .component('talksComponent', Talks)
  .component('addTalkComponent', AddTalk)
  .component('editTalkComponent', EditTalk)
  .controller('AddStudentController', AddStudentController)
  .controller('ViewTalkController', ViewTalkController)
  .controller('AddTalkStudentController', AddTalkStudentController)
  .config(config)
  .name;
